import * as yup from "yup";

import { FormikProvider, useFormik } from "formik";

import clsx from "clsx";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import DropdownWithFormik from "../Dropdown/DropdownWithFormik";
import TextInputWithFormik from "../TextInput/TextInputWithFormik";
import CheckinSubmitButton from "./CheckinSubmitButton";
import ReadWorkerQR from "./ReadWorkerQR";
import styles from "./WorkerInfoModal.module.scss";

const CheckInForm = ({
  onSubmit,
  handleValidateId,
  positions,
  line,
  initialValues = {},
  selectedJob,
  reloadWorkers,
}) => {
  const { t } = useTranslation();

  const [checkStatus, setCheckStatus] = useState("waiting");

  const [openModal, setOpenModal] = useState("");

  const fieldRequired = t("general.validation.required");

  const position = !!initialValues.positionId
    ? positions.find((pos) => pos.value === initialValues.positionId)
    : "";

  const validationSchema = yup.object().shape({
    uniqueId: yup.string().required(fieldRequired),
    position: yup.object().when({
      is: () => checkStatus === "checkout",
      then: yup.object(),
      otherwise: yup.object().required(fieldRequired),
    }),
  });

  const formik = useFormik({
    initialValues: {
      uniqueId: "",
      position: position || "",
    },
    validationSchema,
    enableReinitialize: false,
    onSubmit: (values) =>
      onSubmit(values, setSubmitting, resetForm, checkStatus),
  });

  const {
    handleSubmit,
    setFieldValue,
    resetForm,
    values,
    isSubmitting,
    setSubmitting,
  } = formik;

  const disabledCheck =
    isSubmitting ||
    checkStatus === "waiting" ||
    !values.uniqueId ||
    values?.uniqueId?.length !== 8;

  return (
    <div className={clsx(styles.checkinForm)}>
      <div className="bg-dark" style={{ padding: "32px 32px" }}>
        <h1 className="big-text-bold text-light">{t("views.checkin.title")}</h1>
        <p className="text-light">{t("views.checkin.subtitle")}</p>
        <p className="text-light mb-0"><b>{t("views.checkin.disclaimer")}</b></p>
      </div>

      <ReadWorkerQR
        openModal={openModal}
        setOpenModal={setOpenModal}
        job={selectedJob}
        refreshData={() => reloadWorkers(selectedJob?.id)}
      />

      <div
        className="bg-light w-100 d-flex "
        style={{ padding: "16px 32px 32px 32px" }}
      >
        <Form noValidate onSubmit={handleSubmit}>
          <FormikProvider value={formik}>
            <div className="d-flex justify-content-between flex-column">
              <TextInputWithFormik
                label={t("views.checkin.form.userId")}
                name="uniqueId"
                onChange={async (e) => {
                  setFieldValue("uniqueId", e.target.value?.trim());
                  if (e.target.value?.length === 8) {
                    const status = await handleValidateId(
                      e.target.value,
                      setFieldValue
                    );
                    setCheckStatus(status);
                  }
                }}
                required
                type="text"
                containerClass="w-100 fw-bold"
                style={{
                  height: 80,
                  fontSize: 43,
                  color: "#333333",
                }}
              />
              {checkStatus !== "checkout" && (
                <DropdownWithFormik
                  label={t("views.checkin.form.position")}
                  name="position"
                  placeholder={t("views.checkin.form.positionPlaceholder")}
                  options={positions?.filter((p) => {
                    return (
                      ((line?.is_misc && p.is_misc) ||
                      !line?.is_misc) && p.code !== "LINE_LEADER"
                    );
                  })}
                  required
                  maxMenuHeight={95}
                  containerClass="w-100 my-3"
                />
              )}
            </div>
          </FormikProvider>

          <div className="pt-3 d-flex flex-sm-row justify-content-center align-items-end">
            <CheckinSubmitButton
              checkStatus={checkStatus}
              disabledCheck={disabledCheck}
              onClick={() => {
                if (checkStatus === "waiting") {
                  return;
                }
                handleSubmit();
              }}
            />

            <Button
              className="ms-3"
              style={{ minWidth: 160, maxHeight: 39, marginBottom: 1 }}
              variant="secondary"
              onClick={() => {
                setOpenModal("READ");
              }}
            >
              {t("views.dashboard.leader.scan").toUpperCase()}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CheckInForm;
